import { render, staticRenderFns } from "./ToAssignBook.vue?vue&type=template&id=a2457358&"
import script from "./ToAssignBook.vue?vue&type=script&lang=js&"
export * from "./ToAssignBook.vue?vue&type=script&lang=js&"
import style0 from "./ToAssignBook.vue?vue&type=style&index=0&id=a2457358&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports